import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade médico). */
export type FichaCadastralMedicoJob = ReportJob;
export type FichaCadastralMedicoJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Ficha Cadastral (Médico). */
@Injectable({ providedIn: 'root' })
export class FichaCadastralMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'ficha-cadastral-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.fichaCadastralMedico;
}
